// Hợp đồng
export default {
  Code: 1, // Mã
  Name: 2, // Tên
  Multi: 3, // Cộng <>
  Plus: 4, // Cộng
  Empty: 5, // Để trống
  Custom: 6, // Tùy biến hiển thị
};
